module.exports = __webpack_public_path__ + "856a3b722c6be872ecf28fe320feaed0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/location/locationDesktop.png
// module id = 739
// module chunks = 0